export class APICallsQueue {
    currentAbortController = null;
    /**
     * Enqueue an API call so that it can get cancelled if another call is enqueued before it finishes.
     */
    async enqueue(call, options) {
        const lastAbortController = this.currentAbortController;
        const abortController = (this.currentAbortController =
            new AbortController());
        if (lastAbortController) {
            if (options.warnOnAbort) {
                options.logger.warn('Cancelling current pending search query');
            }
            lastAbortController.abort();
        }
        try {
            return await call(abortController?.signal ?? null);
        }
        finally {
            if (this.currentAbortController === abortController) {
                this.currentAbortController = null;
            }
        }
    }
}
